export const REFORMAT_MOTION_PROMPT_ACTION = 'reformat_motion_prompt'

export interface VideoRunningPresentation {
  messageKey:
    | 'videoGeneratorNode.renderingVideo'
    | 'videoGeneratorNode.reformattingMotionPrompt'
    | 'videoGeneratorNode.extractingDialogues'
    | 'videoGeneratorNode.transcribingSpeech'
}

export function getVideoRunningPresentation(
  action: string | null | undefined,
): VideoRunningPresentation {
  if (action === REFORMAT_MOTION_PROMPT_ACTION) {
    return { messageKey: 'videoGeneratorNode.reformattingMotionPrompt' }
  }
  if (action === 'extract_dialogues') {
    return { messageKey: 'videoGeneratorNode.extractingDialogues' }
  }
  if (action === 'run_speech_to_text') {
    return { messageKey: 'videoGeneratorNode.transcribingSpeech' }
  }
  return { messageKey: 'videoGeneratorNode.renderingVideo' }
}
